export default __webpack_public_path__ + "static/media/workout-2.aff51d08.jpg";